import { useMemo } from 'react';
import { Layout } from '@components';
import { RefillCheckupProvider } from './hooks/useRefillCheckup/RefillCheckupProvider';
import { useRefillCheckup } from './hooks/useRefillCheckup';
import { CheckupInfoSlideTemplate } from './components/CheckupInfoSlideTemplate';
import { useBuildPatientAppUrl } from '@hooks';

function PageContent() {
  const {
    currentSlideIndex,
    checkupFailed,
    slides,
    prevSlide,
    toggleCheckupFailed,
  } = useRefillCheckup();

  const patientWebUrl = useBuildPatientAppUrl({
    page: 'onboarding',
  });

  const Slide = useMemo(
    () =>
      checkupFailed
        ? // terminal slide becomes failure UI if  checkupFailed is true
          CheckupInfoSlideTemplate
        : slides[currentSlideIndex],
    [currentSlideIndex, checkupFailed, slides],
  );

  function handleBackClick() {
    if (currentSlideIndex === 0) {
      // redirect to patient app
      window.location.href = patientWebUrl;
    }

    if (checkupFailed) {
      return toggleCheckupFailed();
    }

    prevSlide();
  }

  const isLastSlide = currentSlideIndex === slides.length - 1;

  return (
    <Layout
      currentPosition={currentSlideIndex + 1}
      hideBackButton={isLastSlide || window.history.length <= 1}
      navigationSteps={slides.length}
      onBackClick={handleBackClick}
      className="flex flex-col"
    >
      {Slide ? <Slide /> : null}
    </Layout>
  );
}

export function RefillsMedicationOrderPage() {
  return (
    <RefillCheckupProvider>
      <PageContent />
    </RefillCheckupProvider>
  );
}
